import React from 'react';
import { CoffeeIcon, ListIcon, BarChartIcon, UserIcon, PackageIcon, PlusIcon } from 'lucide-react';
interface LayoutProps {
  children: React.ReactNode;
  activeTab: string;
  setActiveTab: (tab: string) => void;
}
export const Layout: React.FC<LayoutProps> = ({
  children,
  activeTab,
  setActiveTab
}) => {
  return <div className="flex flex-col min-h-screen bg-amber-50 w-full" data-id="element-414">
      <header className="bg-amber-800 text-amber-50 p-4 shadow-md" data-id="element-415">
        <h1 className="text-xl font-bold flex items-center" data-id="element-416">
          <CoffeeIcon className="mr-2" data-id="element-417" />
          Vibebrewing
        </h1>
      </header>
      <main className="flex-1 p-4 overflow-y-auto pb-20" data-id="element-418">{children}</main>
      <nav className="fixed bottom-0 left-0 right-0 bg-amber-800 text-amber-50 shadow-lg" data-id="element-419">
        <div className="flex justify-around items-center" data-id="element-420">
          <button onClick={() => setActiveTab('list')} className={`flex flex-col items-center p-3 w-1/5 ${activeTab === 'list' ? 'bg-amber-700' : ''}`} data-id="element-421">
            <ListIcon size={24} data-id="element-422" />
            <span className="text-xs mt-1" data-id="element-423">Historial</span>
          </button>
          <button onClick={() => setActiveTab('beans')} className={`flex flex-col items-center p-3 w-1/5 ${activeTab === 'beans' ? 'bg-amber-700' : ''}`} data-id="element-424">
            <PackageIcon size={24} data-id="element-425" />
            <span className="text-xs mt-1" data-id="element-426">Granos</span>
          </button>
          <button onClick={() => setActiveTab('add')} className={`flex flex-col items-center justify-center -mt-4 rounded-full w-16 h-16 
              ${activeTab === 'add' ? 'bg-amber-500 text-white shadow-lg' : 'bg-amber-600 text-white shadow-md hover:bg-amber-500'}`} data-id="element-427">
            <div className="flex flex-col items-center" data-id="element-428">
              <PlusIcon size={28} className="mb-0.5" data-id="element-429" />
              <span className="text-xs" data-id="element-430">Nuevo</span>
            </div>
          </button>
          <button onClick={() => setActiveTab('chart')} className={`flex flex-col items-center p-3 w-1/5 ${activeTab === 'chart' ? 'bg-amber-700' : ''}`} data-id="element-431">
            <BarChartIcon size={24} data-id="element-432" />
            <span className="text-xs mt-1" data-id="element-433">Gráficas</span>
          </button>
          <button onClick={() => setActiveTab('account')} className={`flex flex-col items-center p-3 w-1/5 ${activeTab === 'account' ? 'bg-amber-700' : ''}`} data-id="element-434">
            <UserIcon size={24} data-id="element-435" />
            <span className="text-xs mt-1" data-id="element-436">Cuenta</span>
          </button>
        </div>
      </nav>
    </div>;
};